/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbound_Issue_Unknown_FileInputs */

const en_inbound_issue_unknown_file = /** @type {(inputs: Inbound_Issue_Unknown_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`the file does not exist or was deleted`)
};

/**
* | output |
* | --- |
* | "the file does not exist or was deleted" |
*
* @param {Inbound_Issue_Unknown_FileInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_issue_unknown_file = /** @type {((inputs?: Inbound_Issue_Unknown_FileInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Issue_Unknown_FileInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_issue_unknown_file(inputs)
});